const modifiedFields = [
  'filteringName',
  'use',
  'getTableItems',
  'selectGmtValue',
  'selectItemValue',
  'multiDate',
  'startHM',
  'endHM',
  'startDate',
  'endDate'
];
const optionalFields = {
  selectItemValue: {
    oneTime: [],
    everyDay: [],
    manual: ['dayOfWeek']
  }
};
const sortByFields = {
  getTableItems: ['productId'],
  orderBy: ['asc']
};
const modifiedFieldCustom = {
  getTableItems: ['productName', 'productResourceId', 'productId', 'productType']
};
const formatFieldValue = {
  startHM: function (value) {
    if (value.indexOf(':') > -1) return value.replace(':', '');
    return value;
  },
  endHM: function (value) {
    if (value.indexOf(':') > -1) return value.replace(':', '');
    return value;
  }
};
export default {
  modifiedFields,
  modifiedFieldCustom,
  sortByFields,
  optionalFields,
  formatFieldValue
};
